var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83248 15.3448C2.95498 14.6173 2.35499 13.5898 2.08499 12.3898L1.77749 10.9948C1.62749 10.3123 2.03248 9.53976 2.68498 9.27726L3.74999 8.84976L7.8825 7.19227C8.6025 6.90727 9.39748 6.90727 10.1175 7.19227L14.25 8.84976L15.315 9.27726C15.9675 9.53976 16.3725 10.3123 16.2225 10.9948L15.915 12.3898C15.3825 14.7898 13.5 16.4998 10.785 16.4998H7.21499",
    stroke: "#667085",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5V7.5",
    stroke: "#667085",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6V8.84999L10.1175 7.1925C9.39749 6.9075 8.60251 6.9075 7.88251 7.1925L3.75 8.84999V6C3.75 4.7625 4.7625 3.75 6 3.75H12C13.2375 3.75 14.25 4.7625 14.25 6Z",
    stroke: "#667085",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 3.75H7.125V2.25C7.125 1.8375 7.4625 1.5 7.875 1.5H10.125C10.5375 1.5 10.875 1.8375 10.875 2.25V3.75Z",
    stroke: "#667085",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.f0908d3a8c9f6c267d11150f1b9055db.svg";
export { ForwardRef as ReactComponent };